import { render, staticRenderFns } from "./serverDetailPerformanceTab.vue?vue&type=template&id=1fd34a7b&"
import script from "./serverDetailPerformanceTab.vue?vue&type=script&lang=js&"
export * from "./serverDetailPerformanceTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports